import {
  LOAD_DATA,
  RESET_DATA,
  UPDATE_BUNDLED_PRICING,
  UPDATE_TABLE_DATA,
} from '../config/types';
import columnDefs from '../config/table';

export default function tableReducer(state = {}, { type, data }) {
  switch (type) {
    case LOAD_DATA: {
      let totalServices;
      const rowData = data.reduce((acc, dataItem, idx) => {
        totalServices = 0 === idx ? dataItem.totalNumber : totalServices;
        acc.push({
          professionalPricingPercent: 100,
          technicalPricingPercent: 100,
          percent: ((dataItem.totalNumber / totalServices) * 100).toFixed(2),
          ...dataItem,
        });
        return acc;
      }, []);
      const defaultData = rowData.map((row) => Object.assign({}, row));
      return { ...state, columnDefs, rowData, defaultData };
    }
    case RESET_DATA:
      return { ...state, rowData: state.defaultData.map((row) => Object.assign({}, row)) };
    case UPDATE_TABLE_DATA:
      return { ...state, rowData: data };
    case UPDATE_BUNDLED_PRICING:
      return { ...state, bundledPricing: data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/tableReducer.js